export default __webpack_public_path__ + "static/media/video_cover.fdea9256.JPG";